
define('text!modules/form/divider_template.html',[],function () { return '<div class="form-field-divider">\r\n    <div class="divider"></div>\r\n    <button class="clear-fields button button-icon confirm">Ok? <span class="icon icon-trash"></span></button>\r\n    <button class="clear-fields button button-icon delete"><span class="icon icon-trash"></button>\r\n</div>\r\n\r\n';});

